import { makeStyles } from "@material-ui/core/styles";

export const homeStyles = makeStyles({
  root: {
    minWidth: 275,
    position: "relative",
    minHeight: "calc(100vh - 144px) !important",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 84,
  },
  pos: {
    marginBottom: 12,
  },
  welcome: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "calc(100vh - 180px)",
    padding: "1rem",
  },
  welcomeIntro: {
    textAlign: "center",
    padding: "0 0 2rem",
  },
  introTitle: {
    textAlign: "center",
    padding: "0 0 2rem",
    marginBottom: "1rem",
    textTransform: "uppercase",
    fontWeight: 700,
  },
  introCaption: {
    textAlign: "center",
    padding: "0 0 2rem",
    fontSize: "1rem",
  },
});
